// 邮箱绑定 / 更换 — 验证码（OTP）链路。
//
// 后端：{g}/auth/email/bind/send-code|confirm（单码绑定，未绑定用户）
//       {g}/auth/change-email/send-code|confirm（双码更换，已绑定用户）
// spec: docs/superpowers/specs/2026-06-27-profile-email-verify-rebind-design.md
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query'
import { apiClient, ApiClientError, gapi } from './client'

export function bindEmailSendCode(newEmail: string): Promise<unknown> {
  return apiClient.post(gapi('/auth/email/bind/send-code'), { new_email: newEmail })
}
export function bindEmailConfirm(args: { new_email: string; code: string }): Promise<unknown> {
  return apiClient.post(gapi('/auth/email/bind/confirm'), args)
}
export function changeEmailSendCode(args: { target: 'current' | 'new'; new_email?: string }): Promise<unknown> {
  return apiClient.post(gapi('/auth/change-email/send-code'), args)
}
export function changeEmailConfirm(args: {
  new_email: string
  current_code: string
  new_code: string
}): Promise<unknown> {
  return apiClient.post(gapi('/auth/change-email/confirm'), args)
}

export function useBindEmailSendCode(): UseMutationResult<unknown, ApiClientError, string> {
  return useMutation({ mutationFn: bindEmailSendCode })
}
export function useBindEmailConfirm(): UseMutationResult<
  unknown,
  ApiClientError,
  { new_email: string; code: string }
> {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: bindEmailConfirm,
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['profile', 'me'] }),
  })
}
export function useChangeEmailSendCode(): UseMutationResult<
  unknown,
  ApiClientError,
  { target: 'current' | 'new'; new_email?: string }
> {
  return useMutation({ mutationFn: changeEmailSendCode })
}
export function useChangeEmailConfirm(): UseMutationResult<
  unknown,
  ApiClientError,
  { new_email: string; current_code: string; new_code: string }
> {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: changeEmailConfirm,
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['profile', 'me'] }),
  })
}
